import ApiService from './api';
import { ExternalCar } from '../types';

export class ExternalCarService {
    async getCars(params: {
        workshop_id: number;
        skip?: number;
        limit?: number;
        status?: 'available' | 'working' | 'maintenance' | 'no_drive';
        search?: string;
    }): Promise<{ data: ExternalCar[]; pagination: { skip: number; limit: number; total: number; returned: number } }> {
        return ApiService.get<{ data: ExternalCar[]; pagination: { skip: number; limit: number; total: number; returned: number } }>('/external-cars', params);
    }

    async getCarById(id: number, workshop_id: number): Promise<ExternalCar> {
        const response = await ApiService.get<{ data: ExternalCar }>(`/external-cars/${id}`, { workshop_id });
        return response.data;
    }

    async getCarByNumber(number: string, workshop_id: number): Promise<ExternalCar> {
        const response = await ApiService.get<{ data: ExternalCar }>(`/external-cars/number/${number}`, { workshop_id });
        return response.data;
    }

    async getCarByPlate(plate: string, workshop_id: number): Promise<ExternalCar> {
        const response = await ApiService.get<{ data: ExternalCar }>(`/external-cars/plate/${plate}`, { workshop_id });
        return response.data;
    }

    async getAvailableCars(params: {
        workshop_id: number;
        skip?: number;
        limit?: number;
        search?: string;
    }): Promise<{ data: ExternalCar[]; count: number }> {
        return ApiService.get<{ data: ExternalCar[]; count: number }>('/external-cars/status/available', params);
    }

    async getCarsByDriver(driverName: string, params: {
        workshop_id: number;
        skip?: number;
        limit?: number;
    }): Promise<{ data: ExternalCar[]; driver_name: string; count: number }> {
        return ApiService.get<{ data: ExternalCar[]; driver_name: string; count: number }>(`/external-cars/driver/${driverName}/cars`, params);
    }

    async getStats(workshop_id: number): Promise<{
        data: {
            available: number;
            working: number;
            maintenance: number;
            no_drive: number;
            total: number;
        }
    }> {
        return ApiService.get<{
            data: {
                available: number;
                working: number;
                maintenance: number;
                no_drive: number;
                total: number;
            }
        }>('/external-cars/stats/summary', { workshop_id });
    }
}

export default new ExternalCarService();
